import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseEditBillingAddressParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useEditBillingAddress(
	params: UseEditBillingAddressParams,
) {
	return useApiMutation(
		"patch",
		"/shops/{shopId}/return-requests/{returnRequestId}/billing-address",
		{
			onSuccess: (returnRequest: ReturnRequestDto) => {
				params.onSuccess(returnRequest);
			},
		},
	);
}
